import React from "react";

/** Libraries */
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Zoom,
  TransitionProps
} from "@libraries/mui";

/** Styled components */
import * as Styled from "./styles";

/** Interfaces */
export interface Actions {
  text: string;
  action: () => void;
}
interface IProps {
  open: boolean;
  onClose: () => void;
  title: any;
  actions: Actions[];
}

/** Transition helper component */
const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
  ) => <Zoom ref={ref} {...props} />
);

/** Component */
const ActionDialog: React.FC<IProps> = ({
  title,
  open,
  onClose,
  actions,
  children
}) => (
  <Styled.Container
    open={open}
    onClose={onClose}
    aria-labelledby="actionDialog-title"
    aria-describedby="actionDialog-description"
    TransitionComponent={Transition}
  >
    <DialogTitle id="actionDialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="actionDialog-description">
        {children}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      {actions.map((action) => (
        <Button disableRipple key={action.text} onClick={action.action}>
          {action.text}
        </Button>
      ))}
    </DialogActions>
  </Styled.Container>
);

export default ActionDialog;
